
import './App.css';
import Pages from './routes';
// import "@fontsource/inter"
export const App = () => <Pages />;
